import Helper from './Helper';
import NoteFixer from './NoteFixer';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
      pxCorrection
    } = config;
    this.trigger = accordions;
    this.pxCorrection = pxCorrection;

    this.NoteFixer = new NoteFixer();

    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;

    if (this.accordions && this.accordions.length !== 0) {
      this.bindEvents();

      const url = location.href;
      const id = url.split('#');

      if (!!id[1] && (id[1] != 0)) {
        try {
          const accordionToClick = document.querySelector(`#${id[1]}`);
          const accordionToScroll = document.querySelector('#' + id[1]);
          const headerOffset = document.querySelector('.wp-header')?.offsetHeight || 0;
          console.log(headerOffset)
          const elementPosition = accordionToScroll.offsetTop;
          const offsetPosition = elementPosition - headerOffset;
          if (accordionToClick) {
            const accordeonHeader = accordionToClick.querySelector('.ns-accordion__head');
            const accordeonHeaderHeight = accordeonHeader.offsetHeight;
            accordeonHeader.click();
            setTimeout(() => {
              window.scrollTo({
                top: (accordeonHeader.getBoundingClientRect().top + window.scrollY - headerOffset),
                behavior: "smooth"
              });
            }, 1000);
          } else {
            setTimeout(() => {
              window.scrollTo({
                top: (offsetPosition + this.pxCorrection),
                behavior: "smooth"
              });
            }, 1000);
          }
        } catch (error) {
          console.error(error)
        }
      }
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        if (el.classList.contains('active')) {
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
          el.nextElementSibling.classList.remove('active');
        } else {
          console.log("test");
          el.classList.add('active');
          this.NoteFixer.fix(el);
          Helper.slideOpen(el.nextElementSibling, true);
          el.nextElementSibling.classList.add('active');
        }
      });
    });
  }
}

export default Accordion;
